import { useNavigate } from "react-router-dom";
// import { Button } from "ur-ui-kit-tm";
import React, { useState } from "react";

import DashboardWidgets from "../../components/dashboard-widget/DashboardWidgets";
import PageOutline from "../../components/page-outline/PageOutline";
// import AppCard from "../../components/app-card/AppCard";
import Controls from "../../components/controls/Controls";
// import ICONS from "../../constants/icons";
import { useLocalApp } from "../../hooks";
import {
  // AppsContainer,
  // AppsContainerLot,
  // AppsHeaderButton,
  // AppsHeaderContainer,
  ShinyGreeting,
  TempButton,
  TempWrapper,
  WholeWrapper,
} from "./components";

const HomePage = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { runApp } = useLocalApp();

  return (
    <PageOutline>
      <WholeWrapper>
        <DashboardWidgets />
        <Controls />
        <ShinyGreeting>Good Morning!</ShinyGreeting>
        {/* <AppsHeaderContainer>
          Your Apps
          <AppsHeaderButton>
            <Button label="Explore More Apps" color="light_blue" />
          </AppsHeaderButton>
        </AppsHeaderContainer>
        <AppsContainerLot>
          <AppsContainer>
            <AppCard
              description="Make your house clean with only one click"
              name="Clean my house"
              category={{ icon: <ICONS.DashboardBattery /> }}
              coverImg="https://bookdirtbusters.com/wp-content/uploads/2018/10/deep-cleaning-house-checklist.jpeg"
            />
          </AppsContainer>
        </AppsContainerLot> */}
        <TempWrapper>
          {/* <TempHeading>Please click on the button bellow</TempHeading> */}
          <TempButton
            onClick={() => {
              setLoading(true);
              runApp("8d13f2c8-2d01-4744-8fc6-0fb34c5c5b37");
              setTimeout(() => {
                setLoading(false);
                navigate("/demo");
              }, 10000);
            }}
          >
            {loading ? "Navigating..." : "Take me to the presentation"}
          </TempButton>
        </TempWrapper>
      </WholeWrapper>
    </PageOutline>
  );
};

export default HomePage;
